<template>
  <div>
    <ProductDetail v-if="scanType === 'activityProduct'" :infoObj="infoObj" />
    <UploadDetail v-else :infoObj="infoObj" />
  </div>
</template>

<script>
import { activityOrderInfoApi } from '@/api'
import { Toast } from 'vant'
export default {
  name: 'PointsDetail',
  components: {
    ProductDetail: () => import('./components/ProductDetail'),
    UploadDetail: () => import('./components/UploadDetail')
  },
  data () {
    return {
      scanType: '',
      scanId: '',
      infoObj: {}
    }
  },
  created () {
    const { scanType, scanId } = this.$route.query
    this.scanType = scanType
    this.scanId = scanId
    this.getInfo()
  },
  methods: {
    getInfo () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityOrderInfoApi(this.scanId).then(res => {
        Toast.clear()
        const { imgUrl, status } = res.data
        res.data.imgUrl = imgUrl ? imgUrl.split(',') : []
        res.data.statusColor = status === 10 ? '#ee541b' : status === 1 ? '#0db00b' : status === -1 ? '#c4200b' : status === 0 ? '#898989' : '#000'
        res.data.statusText = status === 10 ? 'Completed' : status === 1 ? 'Pending Review' : status === -1 ? 'Rejected' : status === 0 ? 'Under Review' : ''
        this.infoObj = res.data
      })
    }
  }
}
</script>

<style>
</style>
